import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BHMLModelVersions extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  static modelName = 'BHMLModelVersions'
  static instanceDefaults() {
    return {
      version_number: 1,
      accuracy_r2: 0,
      validation_accuracy_r2: 0,
      features_used: [],
      is_active: false,
      ensemble_eligible: false,
      can_rollback_to: false,
      changelog: []
    }
  }
}

const servicePath = 'bh-ml-model-versions';
const servicePlugin = makeServicePlugin({
  Model: BHMLModelVersions,
  service: feathersClient.service(servicePath),
  servicePath
});

feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
